import createPersistedState from 'vuex-persistedstate'
import {
	clearExpiredPersistedSession,
	ensurePersistedSessionStarted,
	getPersistedSessionStorage
} from '~/assets/utils/PersistedSession'

export default ({store, app, redirect, $config}) => {
	const storage = getPersistedSessionStorage()
	if (!storage) {
		return
	}

	const expired = clearExpiredPersistedSession(
		app.$cookies,
		$config.persistedSessionTtlMs,
		{authStorageKeys: $config.persistedSessionAuthStorageKeys}
	)

	createPersistedState({
		paths: [
			'domain',
			'idgroup',
			'filtersdata',
			'presets_motor',
			'presets_home',
			'companydata',
			'currentPayload',
			'loaded',
			'isfilters',
			'isdatatable',
			'role',
			'preset_selected_motor',
			'preset_selected_home',
			'nav_slot',
			'companyName'
		],
		storage,
		key: 'vuex'
	})(store)

	if (expired) {
		store.dispatch('RESET_STATE')
		redirect('/login')
		return
	}

	ensurePersistedSessionStarted()
}
